var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{ref:"tagContainer",staticClass:"tag-container"},[_vm._v(" "+_vm._s(_vm.props.name)+" "),_c('span',{on:{"click":function($event){return _vm.props.deleteFunc(_vm.props.idx)}}},[_c('i',{staticClass:"fa fa-times"})])])}
var staticRenderFns = []

export { render, staticRenderFns }